/*
 * @Description: 多级侧边栏（手风琴效果）
 * @Author: 蔺晨
 * @Date: 2020-03-20
 *
 * @param: data - 对象数组 例：对象必须包含 key或id、child
 * @renderHeader: function - 每一项的渲染函数，参数即为data中的项
 */
import React, { Component } from 'react';
import { Flex, Accordion, List } from 'antd-mobile';
import './index.less';
import { toJS } from 'mobx';
const { Panel } = Accordion;

export default class AccordionMenuView extends Component {
  constructor(props, context) {
    super(props, context);
  }

  renderPanel = (data, itemIndex) => {
    const { renderHeader, activeKeys } = this.props;
    if (!Array.isArray(toJS(data.childrenList)) || data.childrenList.length == 0) {
      return (
        <Panel
          key={data.key || data.id}
          header={renderHeader(data, itemIndex)}
          className="end-level"
        />
      );
    }
    return (
      <Panel
        className={itemIndex == 0 ? this.props.topclassname || '' : ''}
        key={data.key || data.id}
        header={renderHeader(data, itemIndex)}>
        <Accordion
          activeKey={activeKeys && activeKeys[itemIndex + 1]}
          onChange={(key) => this.props.onChange && this.props.onChange(key)}>
          {data.childrenList.map((_val) => this.renderPanel(_val, itemIndex + 1))}
        </Accordion>
      </Panel>
    );
  };

  render() {
    const { data, activeKeys, totaActivityKeys } = this.props;
    return (
      <Accordion
        defaultActiveKey={totaActivityKeys}
        activeKey={totaActivityKeys || (activeKeys && activeKeys[0])}
        onChange={(key) => this.props.onChange && this.props.onChange(key)}>
        {data.map((_val) => this.renderPanel(_val, 0))}
      </Accordion>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/AccordionMenu/index.js